import React, { useMemo } from 'react'

import { MultiSelectComponent, CheckBoxSelection, Inject } from '@syncfusion/ej2-react-dropdowns';

import { getMixedProps } from './blockPublic'
import { useDelayTimer, useEventHandler, useInstData } from 'tyan/public/hooks'

const MultiSelect = ({ config: {
	field, onChange, defaultStyle, that,
	that: { state: { _validStamp } },	// 用于验证的时间戳
} }) => {
	const { me, setState, me: { state: { edited } } } = useInstData()

	const { name, optionName, } = field
	const optionsParas = { ...that.props.optionsParas, ...that.state.optionsParas }
	let { props: { key, locale, noLocale, disabled, clearable, value, options: optionsProp, ...props } } = getMixedProps('_multiSelect', [defaultStyle, field])

	value = value ?? []

	optionsProp = optionsProp ?? optionsParas[optionName || name] ?? []
	// options支持[['text', value], ...]
	// options 支持[{text:'', value:'', xxx:''}, ...]
	const options = useMemo(() => {
		let options = optionsProp.length && Array.isArray(optionsProp[0])
			? optionsProp.map(([text, value]) => ({ text, value }))
			: optionsProp.map(text => ({ text, value: text }))
		options = options.map(({ text, value }) => ({ text: locale ? Tyan.t(text, locale) : text, value }))

		return options
	}, [optionsProp, locale])

	const handleChange = useEventHandler(({ value: newValue }) => {
		!me.state.edited && setState({ edited: true })
		newValue = newValue?.length ? newValue : null
		onChange({ name, newValue, type: 'array' })
	})

	// console.log('value:', value)
	// console.log('options:', options)
	return <MultiSelectComponent {...props}
		cssClass={!value?.length && (edited || _validStamp) ? 't-input-group e-error' : ''}
		dataSource={options}
		value={value}
		fields={{ text: 'text', value: 'value' }}
		mode="CheckBox"
		showSelectAll={true} showDropDownIcon={true} enableSelectionOrder={true} showClearButton={clearable}
		filterType='Contains'
		changeOnBlur={false}
		enabled={!disabled}
		change={handleChange}
	>
		<Inject services={[CheckBoxSelection]} />
	</MultiSelectComponent>
}

const renderMultiSelect = config => {
	const { key } = config.field || {}
	return <MultiSelect key={key} config={config} />
}


export default renderMultiSelect